import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { GeometergeschaeftNummerComponent } from '../../../../shared/widgets/geometergeschaeft-nummer/geometergeschaeft-nummer.component';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { AvMutationsNummerComponent } from '../../../../shared/widgets/av-mutations-nummer/av-mutations-nummer.component';
import { RechtsgueltigHaengigComponent } from '../../../../shared/widgets/tagebuchstatus-selection/tagebuchstatus-selection.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { AvgeometergeschaeftService, GeometergeschaeftSearchRequestMeta } from '../../../../core/av-api';
import { Subscription } from 'rxjs';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { ActivatedRoute, Router } from '@angular/router';
import { keysToTranslate } from '../../../../../i18n/keys-to-translate';
import { submit } from '../geometergeschaeft.functions';
import { PolitischeGemeindeSearchmode } from '../../../../shared/widgets/pol-gemeinde/politische-gemeinde-searchmode';
import VerarbeitungsArtEnum = GeometergeschaeftSearchRequestMeta.VerarbeitungsArtEnum;
import GeschaeftsTypEnum = GeometergeschaeftSearchRequestMeta.GeschaeftsTypEnum;

@Component({
  selector: 'cap-geometergeschaeft-suche-standard',
  templateUrl: './geometergeschaeft-suche-standard.component.html',
  styleUrls: ['./geometergeschaeft-suche-standard.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    GeometergeschaeftNummerComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    AvMutationsNummerComponent,
    RechtsgueltigHaengigComponent,
    TranslatePipe
  ]
})
export class GeometergeschaeftSucheStandardComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  standard: GeometergeschaeftSearchRequestMeta;

  @ViewChild('form', { static: false })
  form: NgForm;

  @ViewChild(GeometergeschaeftNummerComponent, { static: false })
  private geometergeschaetfNummer: GeometergeschaeftNummerComponent;

  polGemeindeSearchMode = PolitischeGemeindeSearchmode.GEOMETERGESCHAEFT_SEARCH;
  private subscription: Subscription;

  protected verarbeitungsArtChoice: Array<VerarbeitungsArtEnum> = [];

  constructor(
    stateService: SearchStateService,
    private geometergeschaeftService: AvgeometergeschaeftService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService
  ) {
    super(stateService);
    keysToTranslate<string>([
      'GeometergeschaeftNummer',
      'avMutationsNummer',
      'Geschäftstyp',
      'DEFAULT_OHNE_GRUNDBUCH',
      'DEFAULT_MIT_GRUNDBUCH',
      'Geometergeschäft',
      'sucheNachGeometergeschäften',
      'NB-Ident'
    ]);
  }

  ngOnInit() {
    this.subscription = this.geometergeschaeftService.searchGeometergeschaeftStandardTemplate().subscribe((template) => {
      this.standard = this.copyLastRequest(template);
      this.initVerarbeitungsArtChoice();
    });
  }

  protected initVerarbeitungsArtChoice() {
    if (!this.standard.geschaeftsTyp) {
      this.verarbeitungsArtChoice = [];
      this.standard.verarbeitungsArt = null;
      return;
    }
    if (this.standard.geschaeftsTyp === GeschaeftsTypEnum.DEFAULT_MIT_GRUNDBUCH) {
      this.verarbeitungsArtChoice = [
        VerarbeitungsArtEnum.STANDARD,
        VerarbeitungsArtEnum.LANDUMLEGUNG,
        VerarbeitungsArtEnum.ERSTERHEBUNG_ERNEUERUNG
      ];
    }
    if (this.standard.geschaeftsTyp === GeschaeftsTypEnum.DEFAULT_OHNE_GRUNDBUCH) {
      this.verarbeitungsArtChoice = [
        VerarbeitungsArtEnum.STANDARD,
        VerarbeitungsArtEnum.AV_BEMERKUNG,
        VerarbeitungsArtEnum.ERSTERHEBUNG_ERNEUERUNG,
        VerarbeitungsArtEnum.FLAECHENBERICHTIGUNG
      ];
    }
  }

  onSubmit(): void {
    this.timepointService.resetTimepoint();
    this.stateService.lastRequest = this.standard;
    const request = { ...this.standard };
    request.geschaeftsTypList = null;
    submit(this.form, 'searchStandard', request, this.router, this.route);
  }

  onReset(): void {
    this.form.reset();
    this.subscription = this.geometergeschaeftService.searchGeometergeschaeftStandardTemplate().subscribe((template) => {
      this.standard = template;
      this.geometergeschaetfNummer.focus();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
